<template>
  <div class="conteudoInterno" id="numeros2022">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
    </div>
    <header class="headerSec">
      <h2>Os números da UBC em 2022</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
        <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
      </div> 
    </header>
    <div class="conteudoInternoBox" ref="infoBox">
      <section class="sectionRow" ref="infoscroll">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcRedBack"></span> 
        </div> 
        <div class="col49 top32">
          <p>E agora focamos os números da UBC, que são o resultado direto dos nossos esforços em documentação, liberação de execuções previamente não identificadas, serviços aos associados e processos internos de distribuição de royalties recebidos do exterior, direitos fonomecânicos e, é claro, nossa participação nos dados de direitos de execução domésticos detalhados anteriormente.</p>
        </div>
      </section>
      <section class="sectionRow top80">
        <div class="col40ponto4 ubcRedBack"></div>
        <div class="col49">
          <div class="col100"> 
            <h4 class="h4Destaque ubcRed sanukBlack">Números de distribuição da UBC</h4>
          </div>
          <div class="col100 spaceBetween top50">
            <div class="col49sub">
              <h3>Direitos de execução pública (nacional)</h3>
              <div class="numerosBox">
                <p>Total:</p>
                <span class="ubcRed sanukBlack">R$ 667.116.399,63</span>
              </div>
              <div class="numerosBox">
                <p>Direitos Autorais:</p>
                <span class="ubcRed sanukBlack">R$ 518.682.011,41</span>
              </div>
              <div class="numerosBox">
                <p>Direitos Conexos:</p>
                <span class="ubcRed sanukBlack">R$ 148.434.398,09</span>
              </div>
            </div>
            <div class="col49sub topMob32">
              <h3>Direitos de execução pública (internacional)</h3>
              <div class="numerosBox">
                <p>Total:</p>
                <span class="ubcRed sanukBlack">R$ 7.425.500,12</span>
              </div>
              <div class="numerosBox">
                <p>Direitos Autorais:</p>
                <span class="ubcRed sanukBlack">R$ 5.254.238,24</span>
              </div>
              <div class="numerosBox">
                <p>Direitos Conexos:</p>
                <span class="ubcRed sanukBlack">R$ 2.171.261,88</span>
              </div>
            </div>
          </div>
          <div class="col100 spaceBetween top32">
            <div class="col49sub">
              <h3>Direitos fonomecânicos (nacional)</h3>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">R$ 3.305.317,02</span>
              </div>
            </div>
            <div class="col49sub topMob32">
              <h3>Direitos fonomecânicos (internacional)</h3>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">R$ 25.191,09</span>
              </div>
            </div>
          </div>
          <div class="col100 top80">
            <h3>Divisão das distribuições da UBC por tipo de titular de direitos</h3>
            <p>A UBC pagou royalties para:</p>
          </div>
          <div class="col100 spaceBetween top32">
            <div class="col49sub">
              <span class="titleDireitos sanukBold">Estrangeiros (representados)</span>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">155.909</span>
                <p>compositores/autores</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">29.595</span>
                <p>editoras</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">3.189</span>
                <p>Intépretes</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">712</span>
                <p>músicos</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">133</span>
                <p>selos</p>
              </div>
            </div>
            <div class="col49sub topMob32">
              <span class="titleDireitos sanukBold">Nacionais (associados diretos)</span>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">21.028</span>
                <p>compositores/autores</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">1.100</span>
                <p>editoras</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">11.848</span>
                <p>Intépretes</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">10.055</span>
                <p>músicos</p>
              </div>
              <div class="numerosBox">
                <span class="ubcRed sanukBlack">6.482</span>
                <p>selos</p>
              </div>
            </div>
          </div>
          <div class="col100 top50 boxEnd">
            <p># de associados diretos da UBC: <span class="ubcRed sanukBlack">55.577</span> (Dezembro 2022)</p>
            <p># de novas obras registradas: <span class="ubcRed sanukBlack">1.242.953</span></p>
            <p># de novas gravações registradas: <span class="ubcRed sanukBlack">428.463</span></p>
            <p># de novos formulários de direitos autorais (cue sheets) registrados: <span class="ubcRed sanukBlack">17.934</span></p>
            <p># de funcionários:<span class="ubcRed sanukBlack">50 masculino/61 feminino</span></p>

            <p>Investimento no programa de assistência social para associados antigos: <span class="ubcRed sanukBlack">R$ 353.495,37</span></p>
          </div>
        </div>
      </section>
    </div>
  </div>
  </template>
  
  <script>
  import { ShareFunctions } from "../assets/js/functions.js";

  export default {
    name: 'OsNumeros2022',
    props:['clicked'],
  
    data() {
      return{
        setaScrollState: false,
      }
    },
    mounted() {

    const conteudo = document.querySelector("#numeros2022");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);

    },
    methods: {
      goNext: function(){
        this.$emit("go-next");
      },
      goBack: function(){
        this.$emit("go-back");
      }, 
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    .numerosBox {
      margin-top: 12px;
    }
    .numerosBox p {
      margin: 0;
      font-size: 16px !important;
    }
    .numerosBox span {
      font-size: 24px;
    }
    .titleDireitos {
      font-size: 16px;
    }
    .boxEnd p span {
      font-size: 24px;
    } 
    @media screen and ( max-width: 800px ) {
      .topMob32 {
        margin-top: 32px;
      }
    } 
  </style>